import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@tvx/ui/design.css';
import './app.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* The console is the whole host now; /v2/ was where it lived while it
        was being ported. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
